export default "__VITE_ASSET__DUVEXbgJ__"